export default class CodeAutoHelperController {
    constructor() {}

    close() {
        this.modalInstance.dismiss('close');
    }
}
